import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMalware = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "none",
		d: "M4 11.2921V9.18937C4 6.32404 6.32401 4 9.19068 4H10.9093M27.9979 20.7084V22.8111C27.9979 25.6764 25.6739 28.0003 22.8072 28.0003H21.0885M28.002 11.2921V9.18937C28.002 6.32271 25.678 4 22.8113 4H21.1355M4 20.7084V22.8111C4 25.6764 6.32401 28.0003 9.19068 28.0003H10.8666M9.36979 10.8177L9.53109 11.7684C9.68043 12.6457 10.2751 13.3791 11.1031 13.7071L12.8364 14.3844M12.1928 16.3461C11.0115 16.2568 9.83541 16.142 8.46875 16.6913M9.36979 22.1948L9.53508 21.2443C9.67775 20.3723 10.2751 19.6429 11.1044 19.3109L12.2205 18.8803M19.7864 18.8803L20.8917 19.3109C21.7197 19.6429 22.3171 20.3723 22.4731 21.2443L22.6264 22.1948M19.8073 16.3461C20.9887 16.2568 22.1647 16.142 23.5313 16.6913M22.6293 10.8177L22.4668 11.7684C22.3175 12.6457 21.7228 13.3791 20.8961 13.7071L19.1615 14.3844M13.7917 13.5153V12.0128C13.7917 10.7915 14.7811 9.80209 16.0024 9.80209C17.2224 9.80209 18.2117 10.7915 18.2117 12.0128V13.5153M16.4847 21.8675H15.5127C13.6793 21.8675 12.1927 20.3807 12.1927 18.546V16.3475C12.1927 14.5141 13.6793 13.026 15.5127 13.026H16.4847C18.318 13.026 19.8047 14.5141 19.8047 16.3475V18.546C19.8047 20.3807 18.318 21.8675 16.4847 21.8675Z",
		stroke: "#596180",
		strokeWidth: 1.8,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgMalware;
